import * as React from 'react';
import ReactDOM from 'react-dom';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  MODAL_STYLES: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FFF',
    padding: '50px',
    height: 500,
    zIndex: 1000
  },
  OVERLAY_STYLES: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, .7)',
    zIndex: 1000
  },
  backdropStyle: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, .7)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalStyle: {
    backgroundColor: 'white',
    borderRadius: 5,
    width: 500,
    minHeight: 300,
    maxHeight: 600,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
    top: '50%',
    left: '50%'
  },
  CardContainer: {
    width: 500,
    '@media (max-width:650px)': {
      width: '90%'
    }
  },
  CardAction: {
    justifyContent: 'space-between',
    padding: '10px 20px'
  },
  CardButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  subTitle: {
    fontSize: '12px',
    marginLeft: '5px'
  }
}));
export default function Modal({ show, children, onClose }) {
  const classes = useStyles();
  if (!show) {
    return null;
  }
  return ReactDOM.createPortal(
    <>
      <div className={classes.backdropStyle}>
        <div className={classes.modalStyle}> {children} </div>
      </div>
    </>,
    document.getElementById('portal')
  );
}
